import React from 'react';
import {
  ReceiptLong as ReceiptLongIcon,
  AddTask as AddTaskIcon,
  Dashboard as DashboardIcon,
  RequestQuote as DepartmentIcon,
} from '@mui/icons-material';
import AddCommentIcon from '@mui/icons-material/AddComment';

import DepartmentLayout from '../Layout/DepartmentLayout';
import Home from './Home';
import HospitalClaims from './HospitalClaims';
import ClaimsReport from './ClaimsReport';
import OutPatient from './OutPatient';

const MENU_ITEMS = [
  { key: 'Home',           label: 'Home',          icon: <ReceiptLongIcon />, component: Home },
  { key: 'HospitalClaims', label: 'Claims',        icon: <AddTaskIcon />,      component: HospitalClaims },
  { key: 'ClaimsReport',   label: 'Claims Report', icon: <DashboardIcon />,    component: ClaimsReport },
  { key: 'OutPatient',     label: 'Documentation', icon: <AddCommentIcon />,   component: OutPatient },
];

export default function Claims() {
  return (
    <DepartmentLayout
      departmentId={30}
      departmentName="Hospital Claims"
      departmentIcon={<DepartmentIcon />}
      menuItems={MENU_ITEMS}
    />
  );
}
